module.exports = __webpack_public_path__ + "img/Add-Logo.b4210ecc.svg";